import { Tooltip } from 'antd';
import styled from 'styled-components';

export const Container = styled(Tooltip)(({ theme }) => ({
  '& .SlabViewer__tooltip .ant-tooltip-inner': {
    background: theme.palette.white,
    color: theme.palette.black,
  },
  height: '60rem',
  width: '80rem',
  '&:not(:last-child)': {
    marginBottom: '20rem',
  },
}));

export const TooltipStrongText = styled.strong({
  display: 'block',
});
